import { Stack } from '@chakra-ui/react';
import {
  RiMenu2Fill,
  RiDashboardLine,
  RiCalendarCheckLine,
  RiCompass3Line,
} from 'react-icons/ri';

import { BiCar, BiGasPump } from 'react-icons/bi';
import { GiAutoRepair } from 'react-icons/gi';

import { NavLink } from '../NavLink';
import { NavSection } from '../NavSection';
import { useCan } from '../../../../hooks/useCan';

export function SidebarNav() {
  const userCanSeeFrotas = useCan({
    permissions: ['user_miles_data'],
  });

  return (
    <Stack spacing="12" align="flex-start">
      <NavSection title="GERAL">
        <NavLink to="/menu" icon={RiMenu2Fill}>
          Menu
        </NavLink>

        <NavLink to="/miles/dashboard" icon={RiDashboardLine}>
          Dashboard
        </NavLink>
      </NavSection>

      <NavSection title="GESTÃO DE FROTA">
        <NavLink to="/miles/schedule" icon={RiCalendarCheckLine}>
          Agenda
        </NavLink>

        <NavLink to="/miles/kilometers" icon={RiCompass3Line}>
          Quilometragem interno
        </NavLink>

        <NavLink to="/miles/driver-kilometers" icon={RiCompass3Line}>
          Quilometragem terceiros
        </NavLink>
        <NavLink to="/miles/supply" icon={BiGasPump}>
          Abastecimento
        </NavLink>

        <NavLink to="/miles/maintenance" icon={GiAutoRepair}>
          Manutenção
        </NavLink>

        {/* <NavLink to="/miles/expenses" icon={RiMoneyDollarCircleLine}>
          Despesas (Ressarcimento)
        </NavLink> */}

        {userCanSeeFrotas && (
          <NavLink to="/miles/vehicles" icon={BiCar}>
            Frota
          </NavLink>
        )}
      </NavSection>
    </Stack>
  );
}
